import { render, staticRenderFns } from "./layer-add-edit-unit-price.vue?vue&type=template&id=2909dcc3&scoped=true&"
import script from "./layer-add-edit-unit-price.vue?vue&type=script&lang=js&"
export * from "./layer-add-edit-unit-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909dcc3",
  null
  
)

export default component.exports